/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Fs_OnlyInputs */

const en_subtitle_export_fs_only = /** @type {(inputs: Subtitle_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FS Only`)
};

const fr_subtitle_export_fs_only = /** @type {(inputs: Subtitle_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FS uniquement`)
};

const de_subtitle_export_fs_only = /** @type {(inputs: Subtitle_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur FS`)
};

const it_subtitle_export_fs_only = /** @type {(inputs: Subtitle_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo FS`)
};

const ru_subtitle_export_fs_only = /** @type {(inputs: Subtitle_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только FS`)
};

const es_subtitle_export_fs_only = /** @type {(inputs: Subtitle_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo FS`)
};

const zh_cn2_subtitle_export_fs_only = /** @type {(inputs: Subtitle_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅限FS`)
};

const ja_subtitle_export_fs_only = /** @type {(inputs: Subtitle_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FSのみ`)
};

const hi_subtitle_export_fs_only = /** @type {(inputs: Subtitle_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल एफएस`)
};

const pt_pt2_subtitle_export_fs_only = /** @type {(inputs: Subtitle_Export_Fs_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente FS`)
};

/**
* | output |
* | --- |
* | "FS Only" |
*
* @param {Subtitle_Export_Fs_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_fs_only = /** @type {((inputs?: Subtitle_Export_Fs_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Fs_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_fs_only(inputs)
	if (locale === "de") return de_subtitle_export_fs_only(inputs)
	if (locale === "it") return it_subtitle_export_fs_only(inputs)
	if (locale === "ru") return ru_subtitle_export_fs_only(inputs)
	if (locale === "es") return es_subtitle_export_fs_only(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_fs_only(inputs)
	if (locale === "ja") return ja_subtitle_export_fs_only(inputs)
	if (locale === "hi") return hi_subtitle_export_fs_only(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_fs_only(inputs)
	return en_subtitle_export_fs_only(inputs)
});